"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedisStorageClient = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _basicBasketDetailsRedis = require("../helpers/basicBasketDetailsRedis");
var _logger = require("../logger/logger");
class RedisStorageClient {
  constructor(redisMutation) {
    this.redisMutation = redisMutation;
  }
  setItem(key, value, additionalParams) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      try {
        yield (0, _basicBasketDetailsRedis.setBasketDetailsRedis)(value, key, additionalParams, _this.redisMutation);
      } catch (error) {
        _logger.logger.error({
          message: 'Error setting item in RedisStorageClient:',
          error
        });
        throw error;
      }
    })();
  }
  getItem() {
    return (0, _asyncToGenerator2.default)(function* () {
      _logger.logger.info({
        message: 'getItem is not implemented for Client side.'
      });
      return null;
    })();
  }
  removeItem() {
    return (0, _asyncToGenerator2.default)(function* () {
      _logger.logger.info({
        message: 'removeItem is not implemented for Client side.'
      });
    })();
  }
}
exports.RedisStorageClient = RedisStorageClient;